import { createSlice } from '@reduxjs/toolkit';

export interface ThemeState {
  themeColor: string;
  themeLogo: any;
}

const initialState: ThemeState = {
  themeColor: '#4285f4',
  themeLogo: ''
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    changeTheme(state, action) {
      state.themeColor = '#059ee3';
      state.themeLogo = action.payload.uploadLogo;
    }
  }
});

export const { changeTheme } = themeSlice.actions;
export default themeSlice.reducer;
